<script>
import { v4 as uuidv4 } from "uuid";
import Multiselect from "vue-multiselect";
import ClassicEditor from "ckeditor5-build-classic-with-font";
import CKEditor from "@ckeditor/ckeditor5-vue";
import * as categoryService from "../../service/category.service";

export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      value: Array.isArray(this.item_value) ? this.item_value : [],
      isModalVisible: false,
      new_item: "",
      options: ["Text Area", "Image"],
      leveldisplay: true,
      editor: ClassicEditor,
      d_check: this.selectedItem
        ? this.selectedItem[this.item.displayOn]
        : false,
      layout: {
        single: {
          name: "single",
          value: "single",
          displayName: "Single Image",
          icon: "singlelayout.svg",
        },
        double: {
          name: "double",
          value: "double",
          displayName: "Double Image",
          icon: "doublelayout.svg",
        },
        triple: {
          name: "triple",
          value: "triple",
          displayName: "Triple Image",
          icon: "triple.svg",
        },
        imagetext: {
          name: "imagetext",
          value: "imagetext",
          displayName: "Image - Text",
          icon: "imagetext.svg",
        },
        textimage: {
          name: "textimage",
          value: "textimage",
          displayName: "Text - Image",
          icon: "textimage.svg",
        },
      },
      imageLayoutOptions: [
        {
          name: "single",
        },
        {
          name: "double",
        },
        {
          name: "triple",
        },
        {
          name: "imagetext",
        },
        {
          name: "textimage",
        },
      ],
      imageOptions: [],
    };
  },
  methods: {
    handleTextAreaInput(index, key, event) {
      //   console.log(index, key, this.value[index].caption1);
      this.value[index][key] = event.target.value;
    },
    optionHandle() {
      console.log("optionHandle called");
    },
    toggleModal() {
      this.isModalVisible = !this.isModalVisible;
    },
    addPPG() {
      this.value.push({
        id: uuidv4(),
        contentType: "Text Area",
        contentDescription: "",
        imageLayout: "single",
        image1: "",
        caption1: "",
        image2: "",
        caption2: "",
        image3: "",
        caption3: "",
        image_text_image: "",
        image_text_description: "",
        text_image_image: "",
        text_image_description: "",
      });
    },
    removeItem(index) {
      this.value.splice(index, 1);
    },
    async getOptions() {
      let filter = {
        where: {
          name: "Documents",
          cmsId: this.$route.params.cmsId,
        },
        include: [
          {
            relation: "pages",
          },
        ],
      };

      filter = encodeURIComponent(JSON.stringify(filter));

      let data = await categoryService.getWithFilter(filter);
      let pages = data.length ? data[0].pages : [];
      let validFileFormats = [
        "image/apng",
        "image/avif",
        "image/gif",
        "image/jpeg",
        "image/png",
        "image/svg+xml",
        "image/webp",
      ];
      this.imageOptions = pages.filter((x) =>
        validFileFormats.includes(x.additionalProp1.fileFormat)
      );
      // this.value = this.options.filter((x) => x.url == this.item_value)[0];
    },
  },
  components: {
    Multiselect,
    ckeditor: CKEditor.component,
  },
  computed: {
    level_two_display() {
      if (this.item_key === "pharmacy_list") {
        return this.leveldisplay && this.display_none_check;
      }
      return this.display_none_check;
    },
    display_none_check: {
      get: function () {
        return this.d_check;
      },
      set: function (newValue) {
        this.d_check = newValue;
      },
    },
    editorConfig() {
      return {
        toolbar: [
          "heading",
          "|",
          "fontColor",
          "|",
          "bold",
          "link",
          "bulletedList",
          "numberedList",
          "blockQuote",
          "insertTable",
          "undo",
          "redo",
        ],
        heading: {
          options: [
            {
              model: "paragraph",
              title: "Paragraph",
              class: "ck-heading_paragraph",
            },
            {
              model: "heading1",
              view: "h1",
              title: "Heading 1",
              class: "ck-heading_heading1",
            },
            {
              model: "heading2",
              view: "h2",
              title: "Heading 2",
              class: "ck-heading_heading2",
            },
            {
              model: "heading3",
              view: "h3",
              title: "Heading 3",
              class: "ck-heading_heading3",
            },
            {
              model: "heading4",
              view: "h4",
              title: "Heading 4",
              class: "ck-heading_heading4",
            },
          ],
        },
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
        },
        fontColor: {
          colors: [
            {
              color: "#005EB8",
              label: "Blue",
            },
            {
              color: "#FF2E2E",
              label: "Red",
            },
            {
              color: "#4F535B",
              label: "Main Grey",
            },
          ],
        },
        link: {
          decorators: {
            toggleDownloadable: {
              mode: "manual",
              label: "Downloadable",
              attributes: {
                download: "file",
              },
            },
            openInNewTab: {
              mode: "manual",
              label: "Open in a new tab",
              attributes: {
                target: "_blank",
                rel: "noopener noreferrer",
              },
            },
          },
        },
      };
    },
  },
  watch: {
    last_updated: {
      handler(val) {
        if (val && this.item.displayOn && val.key == this.item.displayOn) {
          this.display_none_check =
            JSON.stringify(val.value) == this.item.displayOnValue
              ? true
              : false;
        }
      },
      deep: true,
    },
    item_value: {
      handler(val) {
        this.value = val;
      },
      deep: true,
    },
    selectedItem: {
      handler() {
        this.optionHandle();
      },
      deep: true,
    },
    value(val) {
      this.updateValue(this.item_key, val);
    },
    display_none_check(val) {
      this.item.display = this.item.displayOn && !val ? false : true;
    },
  },
  async mounted() {
    console.log("this.value", this.value);
    if (!this.value.length) {
      this.addPPG();
    }
    await this.getOptions();
    this.optionHandle();
  },
};
</script>

<template>
  <div :class="{ 'd-none': item.displayOn && !level_two_display }">
    <b-modal
      v-model="isModalVisible"
      style="letter-spacing: 2em"
      id="add-ppg-newsletters"
      centered
      title="Add Item"
      title-class="font-18"
      hide-footer
    >
      <div class="d-flex mb-3">
        <input v-model="new_item" type="text" class="form-control mr-2" />
        <button
          class="btn btn-primary"
          @click="
            addPPG(new_item);
            $bvModal.hide('add-ppg-newsletters');
          "
        >
          Add
        </button>
      </div>
    </b-modal>
    <div class="full-width-flex">
      <div class="w100">
        <div class="section-label">{{ item.label }}</div>
        <div
          v-for="(sg, index) in value"
          :key="sg.id"
          class="d-flex mb-2 col-8 p-0"
        >
          <div class="section-1">
            {{ `Section ${index + 1}` }}
          </div>
          <multiselect
            v-model="sg.contentType"
            :options="options"
            :searchable="false"
            :close-on-select="true"
            :show-labels="false"
            :allow-empty="false"
            :placeholder="item.placeholder"
          ></multiselect>
          <a
            class="font-size-14 mb-2 font-weight-medium ml-3 align-self-sm-center"
            role="button"
            style="color: #da3f3f"
            @click="removeItem(index)"
            >Remove</a
          >
        </div>
        <div class="mt-2">
          <a
            class="font-size-14 mb-2 ml-auto align-self-sm-center cursor-pointer"
            @click="addPPG()"
            >+ Add Item</a
          >
        </div>
        <div class="mb-3">
          <hr />
        </div>
        <div class="mt-2">
          <div v-for="(sg, index) in value" :key="index">
            <div class="section-1 mb-20 mt-20">
              {{ `Section ${index + 1}` }}
            </div>
            <template v-if="sg.contentType === 'Text Area'">
              <div class="image-label">
                {{ "Description" }}
              </div>
              <ckeditor
                v-model="sg.contentDescription"
                :editor="editor"
                :config="editorConfig"
              ></ckeditor>
              <div class="mb-3">
                <hr />
              </div>
            </template>

            <template v-else>
              <div class="mb-3 layout-section">
                <div class="flex col-12 mt-2 radio-container">
                  <div
                    v-for="option in imageLayoutOptions"
                    v-bind:key="option.name"
                    class="form-check"
                  >
                    <div class="image-display-section">
                      <img
                        :src="
                          require(`@/assets/images/${layout[option.name].icon}`)
                        "
                      />
                    </div>
                    <div class="checkbox-input">
                      <input
                        class="form-check-input"
                        type="radio"
                        v-model="sg.imageLayout"
                        v-bind:value="option"
                      />
                      <label class="form-check-label ml-2">{{
                        layout[option.name].displayName || option.name
                      }}</label>
                    </div>
                  </div>
                </div>

                <div
                  v-if="submitted && validation.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!validation.required"
                    >This value is required.</span
                  >
                </div>
              </div>
              <template v-if="sg.imageLayout">
                <div
                  v-if="sg.imageLayout.name === 'single'"
                  class="image-section"
                >
                  <div class="mb-3 col-6 p-0">
                    <div>
                      <div class="image-label">
                        {{ "Image" }}
                      </div>
                      <multiselect
                        track-by="title"
                        label="title"
                        v-model="sg.image1"
                        :options="imageOptions"
                        :searchable="imageOptions.length > 5 ? true : false"
                        :close-on-select="true"
                        :show-labels="false"
                        :placeholder="item.placeholder"
                        :allow-empty="true"
                        :preselectFirst="true"
                      >
                        <template slot="singleLabel" slot-scope="{ option }">
                          <span class="option__desc">
                            <span class="option__title">{{
                              option.title
                            }}</span>
                          </span>
                        </template>
                        <template slot="option" slot-scope="{ option }">
                          <img
                            class="option__image"
                            :src="option.url"
                            alt="Image"
                            style="height: 5em"
                          />
                          <div class="option__desc pt-3">
                            <span class="option__title">{{
                              option.title
                            }}</span>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                    <div class="caption-section">
                      <div class="image-label">
                        {{ "Caption" }}
                      </div>
                      <textarea
                        :key="index"
                        class="pl-form-input pl-form-input__textarea caption-text-area"
                        :value="sg.caption1"
                        @input="
                          ($event) => {
                            handleTextAreaInput(index, 'caption1', $event);
                          }
                        "
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div
                  v-if="sg.imageLayout.name === 'double'"
                  class="image-section"
                >
                  <div class="mb-3 col-6 p-0">
                    <div>
                      <div class="image-label">
                        {{ "Image 1" }}
                      </div>
                      <multiselect
                        track-by="title"
                        label="title"
                        v-model="sg.image1"
                        :options="imageOptions"
                        :searchable="imageOptions.length > 5 ? true : false"
                        :close-on-select="true"
                        :show-labels="false"
                        :placeholder="item.placeholder"
                        :allow-empty="true"
                        :preselectFirst="true"
                      >
                        <template slot="singleLabel" slot-scope="{ option }">
                          <span class="option__desc">
                            <span class="option__title">{{
                              option.title
                            }}</span>
                          </span>
                        </template>
                        <template slot="option" slot-scope="{ option }">
                          <img
                            class="option__image"
                            :src="option.url"
                            alt="Image"
                            style="height: 5em"
                          />
                          <div class="option__desc pt-3">
                            <span class="option__title">{{
                              option.title
                            }}</span>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                    <div class="caption-section">
                      <div class="image-label">
                        {{ "Caption" }}
                      </div>
                      <textarea
                        class="pl-form-input pl-form-input__textarea caption-text-area"
                        :value="sg.caption1"
                        @input="
                          ($event) => {
                            handleTextAreaInput(index, 'caption1', $event);
                          }
                        "
                      ></textarea>
                    </div>
                  </div>
                  <div class="mb-3 col-6">
                    <div>
                      <div class="image-label">
                        {{ "Image 2" }}
                      </div>
                      <multiselect
                        track-by="title"
                        label="title"
                        v-model="sg.image2"
                        :options="imageOptions"
                        :searchable="imageOptions.length > 5 ? true : false"
                        :close-on-select="true"
                        :show-labels="false"
                        :placeholder="item.placeholder"
                        :allow-empty="true"
                        :preselectFirst="true"
                      >
                        <template slot="singleLabel" slot-scope="{ option }">
                          <span class="option__desc">
                            <span class="option__title">{{
                              option.title
                            }}</span>
                          </span>
                        </template>
                        <template slot="option" slot-scope="{ option }">
                          <img
                            class="option__image"
                            :src="option.url"
                            alt="Image"
                            style="height: 5em"
                          />
                          <div class="option__desc pt-3">
                            <span class="option__title">{{
                              option.title
                            }}</span>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                    <div class="caption-section">
                      <div class="image-label">
                        {{ "Caption" }}
                      </div>
                      <textarea
                        class="pl-form-input pl-form-input__textarea caption-text-area"
                        :value="sg.caption2"
                        @input="
                          ($event) => {
                            handleTextAreaInput(index, 'caption2', $event);
                          }
                        "
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div
                  v-if="sg.imageLayout.name === 'triple'"
                  class="image-section"
                >
                  <div class="mb-3 col-6 p-0">
                    <div>
                      <div class="image-label">
                        {{ "Image 1" }}
                      </div>
                      <multiselect
                        track-by="title"
                        label="title"
                        v-model="sg.image1"
                        :options="imageOptions"
                        :searchable="imageOptions.length > 5 ? true : false"
                        :close-on-select="true"
                        :show-labels="false"
                        :placeholder="item.placeholder"
                        :allow-empty="true"
                        :preselectFirst="true"
                      >
                        <template slot="singleLabel" slot-scope="{ option }">
                          <span class="option__desc">
                            <span class="option__title">{{
                              option.title
                            }}</span>
                          </span>
                        </template>
                        <template slot="option" slot-scope="{ option }">
                          <img
                            class="option__image"
                            :src="option.url"
                            alt="Image"
                            style="height: 5em"
                          />
                          <div class="option__desc pt-3">
                            <span class="option__title">{{
                              option.title
                            }}</span>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                    <div class="caption-section">
                      <div class="image-label">
                        {{ "Caption" }}
                      </div>
                      <textarea
                        class="pl-form-input pl-form-input__textarea caption-text-area"
                        :value="sg.caption1"
                        @input="
                          ($event) => {
                            handleTextAreaInput(index, 'caption1', $event);
                          }
                        "
                      ></textarea>
                    </div>
                  </div>
                  <div class="mb-3 col-6">
                    <div>
                      <div class="image-label">
                        {{ "Image 2" }}
                      </div>
                      <multiselect
                        track-by="title"
                        label="title"
                        v-model="sg.image2"
                        :options="imageOptions"
                        :searchable="imageOptions.length > 5 ? true : false"
                        :close-on-select="true"
                        :show-labels="false"
                        :placeholder="item.placeholder"
                        :allow-empty="true"
                        :preselectFirst="true"
                      >
                        <template slot="singleLabel" slot-scope="{ option }">
                          <span class="option__desc">
                            <span class="option__title">{{
                              option.title
                            }}</span>
                          </span>
                        </template>
                        <template slot="option" slot-scope="{ option }">
                          <img
                            class="option__image"
                            :src="option.url"
                            alt="Image"
                            style="height: 5em"
                          />
                          <div class="option__desc pt-3">
                            <span class="option__title">{{
                              option.title
                            }}</span>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                    <div class="caption-section">
                      <div class="image-label">
                        {{ "Caption" }}
                      </div>
                      <textarea
                        class="pl-form-input pl-form-input__textarea caption-text-area"
                        :value="sg.caption2"
                        @input="
                          ($event) => {
                            handleTextAreaInput(index, 'caption2', $event);
                          }
                        "
                      ></textarea>
                    </div>
                  </div>
                  <div class="mb-3 col-6 p-0">
                    <div>
                      <div class="image-label">
                        {{ "Image 3" }}
                      </div>
                      <multiselect
                        track-by="title"
                        label="title"
                        v-model="sg.image3"
                        :options="imageOptions"
                        :searchable="imageOptions.length > 5 ? true : false"
                        :close-on-select="true"
                        :show-labels="false"
                        :placeholder="item.placeholder"
                        :allow-empty="true"
                        :preselectFirst="true"
                      >
                        <template slot="singleLabel" slot-scope="{ option }">
                          <span class="option__desc">
                            <span class="option__title">{{
                              option.title
                            }}</span>
                          </span>
                        </template>
                        <template slot="option" slot-scope="{ option }">
                          <img
                            class="option__image"
                            :src="option.url"
                            alt="Image"
                            style="height: 5em"
                          />
                          <div class="option__desc pt-3">
                            <span class="option__title">{{
                              option.title
                            }}</span>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                    <div class="caption-section">
                      <div class="image-label">
                        {{ "Caption" }}
                      </div>
                      <textarea
                        class="pl-form-input pl-form-input__textarea caption-text-area"
                        :value="sg.caption3"
                        @input="
                          ($event) => {
                            handleTextAreaInput(index, 'caption3', $event);
                          }
                        "
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div
                  v-if="sg.imageLayout.name === 'imagetext'"
                  class="image-section"
                >
                  <div class="mb-3 col-6 p-0">
                    <div>
                      <div class="image-label">
                        {{ "Image" }}
                      </div>
                      <multiselect
                        track-by="title"
                        label="title"
                        v-model="sg.image_text_image"
                        :options="imageOptions"
                        :searchable="imageOptions.length > 5 ? true : false"
                        :close-on-select="true"
                        :show-labels="false"
                        :placeholder="item.placeholder"
                        :allow-empty="true"
                        :preselectFirst="true"
                      >
                        <template slot="singleLabel" slot-scope="{ option }">
                          <span class="option__desc">
                            <span class="option__title">{{
                              option.title
                            }}</span>
                          </span>
                        </template>
                        <template slot="option" slot-scope="{ option }">
                          <img
                            class="option__image"
                            :src="option.url"
                            alt="Image"
                            style="height: 5em"
                          />
                          <div class="option__desc pt-3">
                            <span class="option__title">{{
                              option.title
                            }}</span>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                  </div>
                  <div class="mb-3 col-12 p-0">
                    <div class="caption-section">
                      <div class="image-label">
                        {{ "Description" }}
                      </div>
                      <ckeditor
                        v-model="sg.image_text_description"
                        :editor="editor"
                        :config="editorConfig"
                      ></ckeditor>
                    </div>
                  </div>
                </div>
                <div
                  v-if="sg.imageLayout.name === 'textimage'"
                  class="image-section"
                >
                  <div class="mb-3 col-6 p-0">
                    <div>
                      <div class="image-label">
                        {{ "Image" }}
                      </div>
                      <multiselect
                        track-by="title"
                        label="title"
                        v-model="sg.text_image_image"
                        :options="imageOptions"
                        :searchable="imageOptions.length > 5 ? true : false"
                        :close-on-select="true"
                        :show-labels="false"
                        :placeholder="item.placeholder"
                        :allow-empty="true"
                        :preselectFirst="true"
                      >
                        <template slot="singleLabel" slot-scope="{ option }">
                          <span class="option__desc">
                            <span class="option__title">{{
                              option.title
                            }}</span>
                          </span>
                        </template>
                        <template slot="option" slot-scope="{ option }">
                          <img
                            class="option__image"
                            :src="option.url"
                            alt="Image"
                            style="height: 5em"
                          />
                          <div class="option__desc pt-3">
                            <span class="option__title">{{
                              option.title
                            }}</span>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                  </div>
                  <div class="mb-3 col-12 p-0">
                    <div class="caption-section">
                      <div class="image-label">
                        {{ "Description" }}
                      </div>
                      <ckeditor
                        v-model="sg.text_image_description"
                        :editor="editor"
                        :config="editorConfig"
                      ></ckeditor>
                    </div>
                  </div>
                </div>
              </template>
              <div class="mb-3">
                <hr />
              </div>
            </template>
          </div>
        </div>
        <div v-if="submitted && validation.$error" class="invalid-feedback">
          <span v-if="!validation.required">This value is required.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.checkbox-input {
  padding-top: 20px;
  margin-left: 20px;
}
.checkbox-input .form-check-input {
  transform: scale(1.5);
  cursor: pointer;
  accent-color: #005eb8 !important;
}
.section-label {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #333;
  padding-bottom: 20px;
}
.full-width-flex {
  display: inline-flex;
  width: 100%;
}
.w100 {
  width: 100%;
}
.image-label {
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #333;
  margin-bottom: 5px;
}
.caption-section {
  margin-top: 10px;
}
.caption-text-area {
  background: #fff;
  border-radius: 3px;
  font-size: 14px;
}
.image-section {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.checkbox-input {
  cursor: pointer;
  margin-top: 5px;
}
.layout-section {
  margin-top: 35px;
  position: relative;
  right: 16px;
}
.radio-container {
  display: flex;
  justify-content: space-around;
  padding: 0px;
}
.image-display-section {
  /* position: relative;
  right: 20px; */
}
.section-1 {
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #333;
  margin-right: 14px;
  margin-top: 8px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mt-20 {
  margin-top: 20px;
}
</style>
